export default "__VITE_ASSET__67a8eb92__"